/**
 * Sự kiện (Thanh Tịnh Pháp — Sự kiện Phật pháp) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute, redirect } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const EventsListPage = lazy(() =>
  import("@/features/events").then((mod) => ({ default: mod.EventsListPage })),
);
const EventCreatePage = lazy(() =>
  import("@/features/events").then((mod) => ({ default: mod.EventCreatePage })),
);
const EventDetailPage = lazy(() =>
  import("@/features/events").then((mod) => ({ default: mod.EventDetailPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const eventsListRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/su-kien/danh-sach",
  component: withSuspense(EventsListPage),
});
const eventsCreateRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/su-kien/danh-sach/tao-moi",
  component: withSuspense(EventCreatePage),
});
const eventsCreateLegacyRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/su-kien/tao-moi",
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirect pattern
    throw redirect({ to: "/su-kien/danh-sach/tao-moi" });
  },
});
const eventsDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/su-kien/danh-sach/$publicId",
  component: withSuspense(EventDetailPage),
});

export const suKienRoutes = [
  eventsListRoute,
  eventsCreateRoute,
  eventsCreateLegacyRoute,
  eventsDetailRoute,
];
